import React, { useEffect, useState } from "react";

// reactstrap components
import {
	Card,
	CardHeader,
	CardBody,
	Table,
	Row,
	FormGroup,
	Input,
	Label,
	Collapse,
	Col,
	Button
} from "reactstrap";
import * as moment from "moment";
import { Link } from "react-router-dom";
import { STATUS_LIST, DATE_FORMATS, PAGE_LIMIT, MESSAGES } from '../../configs/constant'

import { BLOCKS, STATES, DISTRICTS } from '../../configs/urls'
import { getApi, deleteApi } from '../../services/api'

import Loader from '../../components/Loader'
import Toaster from "../../components/Toaster";

import './styles.css'
import { FaEdit } from 'react-icons/fa'
import axios from 'axios'

const Blocks = () => {

	const [isRequesting, setIsRequestig] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [canShowLoadMore, setCanShowLoadMore] = useState(false);

	const [isFilterOpen, setIsFilterOpen] = useState(false)
	const [filterParams, setFilterParams] = useState({
		page: 0,
		size: PAGE_LIMIT,
		state_id: 20
	})
	const [states, setStates] = useState([])
	const [districts, setDistricts] = useState([])
	const [blocks, setBlocks] = useState([])

	useEffect(() => {
		getAllData()
	}, []);

	const getAllData = () => {
		setIsRequestig(true);

		const states = getApi(STATES);
		const districts = getApi(DISTRICTS, {state_id: filterParams.state_id});
		const blocks = getApi(BLOCKS, filterParams);

		axios
			.all([states, districts, blocks])
			.then((res) => {


				if (res[0] && res[0].data) {
					setStates(res[0].data)
				}

				if (res[1] && res[1].data) {
					setDistricts(res[1].data)
				}

				if (res[2] && res[2].data) {
					setBlocks(res[2].data)
					setCanShowLoadMore(res[2].data.length < res[2].meta.total)
				}
			})
			.catch(() => {

			}).finally(() => {
				setIsRequestig(false)
			})
	};

	const fetchBlocks = (isLoadMore) => {
		setIsLoading(true);

		const params = JSON.parse(JSON.stringify(filterParams))

		for (const key in params) {
			if ((!params[key] && params[key] != 0) || params[key] == -1) {
				delete params[key]
			}
		}

		getApi(BLOCKS, params)
			.then((res) => {
				let blocksData = isLoadMore ? [...blocks, ...res.data] : res.data;
				setBlocks(blocksData || []);
				setCanShowLoadMore(blocksData.length < res.meta.total)
			}, (err) => {
				console.log(err);
			}).finally(() => {
				setIsLoading(false);
			})
	}

	const deleteBlock = (blockId) => {
		var proceed = window.confirm("Are you sure you want to delete block?");
		if (proceed) {
			deleteApi(`${BLOCKS}/${blockId}`)
				.then((res) => {
					let list = blocks
					list = list.filter(item => item.id != blockId)
					setBlocks(list)
					Toaster.showSuccess(res.message || 'District deleted successfully.')
				}, (err) => {
					Toaster.showError(err.message)
				})
		}
	}

	const handleChange = (event) => {
		event.persist();
		setFilterParams(values => ({ ...values, [event.target.name]: event.target.value }));
	};

	const resetFilter = () => {
		setFilterParams({
			state_id: -1,
			district_id: -1,
			block_id: -1,
			status: -1,
			name: '',
			page: 0,
			size: PAGE_LIMIT
		});

		fetchBlocks();
	}
	
	const searchBlocks = () => {
		const params = filterParams;
		params.page = 0;

		setFilterParams(params)

		fetchBlocks();
	}

	const loadMoreBlocks = () => {
		const params = filterParams;
		params.page++;

		setFilterParams(params)

		fetchBlocks(true);
	}

	const getDistricts = (stateId) => {
		setIsLoading(true);

		setFilterParams({...filterParams, district_id: -1});

		getApi(DISTRICTS, { state_id: stateId }).then(res => {
			setDistricts(res.data)
		}).catch(() => { }).finally(() => {
			setIsLoading(false)
		})
	}


	const renderBlocks = () => (
		<div className="content">
			<Row>
				<Col md="12">
					<Card>
						<CardHeader className="header-section">
							<div>
								<Button color="primary" onClick={() => setIsFilterOpen(!isFilterOpen)}>Filter</Button>
							</div>
							<Link to="blocks/operations">
								<Button color="primary" className="text-right">Add New Block</Button>
							</Link>
						</CardHeader>
						<Collapse isOpen={isFilterOpen} className="border-top">
							<Card>
								<CardBody>
									<Row>
										<Col className="pr-1" md="4">
											<FormGroup>
												<Label for="stateName">State</Label>
												<Input
													type="select"
													name="state_id"
													value={filterParams.state_id}
													onChange={(e) => {
														getDistricts(e.target.value)
														handleChange(e)
													}}
												>
													<option value={-1}>Select State</option>
													{
														states.map(state => (
															<option key={state.id} value={state.id}>{state.name}</option>
														))
													}
												</Input>
											</FormGroup>
										</Col>
										<Col className="pl-1" md="4">
											<FormGroup>
												<Label for="districtName">District</Label>
												<Input
													type="select"
													name="district_id"
													value={filterParams.district_id}
													onChange={handleChange}
												>
													<option value={-1}>Select District</option>
													{
														districts.map(district => (
															<option key={district.id} value={district.id}>{district.name}</option>
														))
													}
												</Input>
											</FormGroup>
										</Col>
										<Col className="pr-1" md="4">
											<FormGroup>
												<Label for="status">Status</Label>
												<Input
													type="select"
													name="status"
													value={filterParams.status}
													onChange={handleChange}
												>
													{
														STATUS_LIST.map(status => (
															<option key={status.id} value={status.id}>{status.title}</option>
														))
													}
												</Input>
											</FormGroup>
										</Col>
									</Row>
									<Row>
										<Col className="pr-1" md="4">
											<FormGroup>
												<label>Block</label>
												<Input
													type="text"
													name="name"
													placeholder="Block Name"
													value={filterParams.name || ""}
													onChange={handleChange}
												/>
											</FormGroup>
										</Col>

										<Col className="pr-1" md="4">
											<div className="update ml-auto mt-3 mr-auto">
												<Button className="btn-round" onClick={() => searchBlocks()} color="primary">
													Search
												</Button>
												<Button className="btn-round ml-2" onClick={() => resetFilter()} color="primary">
													Reset
												</Button>
											</div>
										</Col>
									</Row>
								</CardBody>
							</Card>
						</Collapse>

						<hr />

						<CardBody>
							<Table>
								<thead className="text-primary">
									<tr>
										<th>ID</th>
										<th>Block Name</th>
										<th>District</th>
										<th>State</th>
										<th>Status</th>
										<th>Last Update</th>
										<th className="text-right">Actions</th>
									</tr>
								</thead>
								<tbody>
									{
										blocks.map((block, idx) => (
											<tr key={idx}>
												<td>{block.id}</td>
												<td>{block.name || '--'}</td>
												<td>{block.district ? block.district.name : '--'}</td>
												<td>{block.state ? block.state.name : '--'}</td>
												<td>{block.status == 1 ? 'Enabled' : 'Disabled'}</td>
												<td>{block.updated_at ? moment(block.updated_at).format(DATE_FORMATS.DATE_TIME_FORMAT) : '--'}</td>
												<td className="text-right action-icons">
													<Link to={`blocks/operations/${block.id}`}>
														<FaEdit />
													</Link>
												</td>
											</tr>
										))
									}
								</tbody>
							</Table>
							{
								blocks.length == 0 &&
								<span className="no-record-found">{MESSAGES.NO_RECORD_FOUND}</span>
							}
						</CardBody>
					</Card>
				</Col>
			</Row>
			{
				canShowLoadMore && 
				<Row>
					<Col className="load-more-col">
						<Button className="action-btn" onClick={() => loadMoreBlocks()} color="primary">Load more</Button>
					</Col>
				</Row>
			}
			<Loader isLoading={isLoading} />
		</div>
	)

	return (
		<>
			{
				isRequesting
					? <div className="content"><Loader isLoading={isRequesting} /></div>
					: renderBlocks()
			}
		</>
	);
}

export default Blocks;
